// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"079f4ab8","513":"42f561bf","703":"ea2ed94f","787":"bf25920c","850":"2467840c"}[chunkId] + ".chunk.js";
};